
<template>
    <vx-card title="" class="carousel-example">
        <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide v-bind:key="index" v-for="(banner, index) in  srcBanners">
              <img class="responsive" v-bind:src="getURL(banner.img_url)" @click="documento(banner.link)" style="width:100%; height:23rem; cursor: pointer;" alt="banner">
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev" title="Anterior"></div>
            <div class="swiper-button-next" slot="button-next" title="Siguiente"></div>
          </swiper>          
    </vx-card>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import StarRating from 'vue-star-rating'

export default {
       data() {
          return {
              srcBanners:[],
              image: null,
              swiperOption: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                  centeredSlides: true,
                  // init: false,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                  },
                  navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev'
                  },
                  autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                  },
                    breakpoints: {
                      1024: {
                          slidesPerView:1,
                          spaceBetween: 40
                      },
                      768: {
                          slidesPerView: 1,
                          spaceBetween: 30
                      },
                      640: {
                          slidesPerView: 1,
                          spaceBetween: 20
                      }
                  }
              }
          }
      },
      components: {
          swiper,
          swiperSlide,
          StarRating
      },
      computed: {
          myImage () {
              return this.image;
            }
      },
      methods: {
        documento(link){
          window.open(link);
        },
        cargaGeneralBanner(){
            this.$http.get(this.$store.state.domain+`mapgrafi/mapgrafi-general/banner-carga-general/${process.env.VUE_APP_COD_EMPRESA_ERP}`)
              .then((response) => {   this.srcBanners  =  response.data.data; 
              this.$forceUpdate(); })
        },
         getURL(assetName) {
          return  require("@/assets/images/carousel/"+assetName);
        }
      },
      created () {
        this.cargaGeneralBanner();
      },
}
</script>
